import { jsxs as a, jsx as r } from "react/jsx-runtime";
import { clsx as g } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { forwardRef as L } from "react";
import { RocheUIButton as T } from "../button/roche-button.js";
import { RocheUIButtonSize as b, RocheUIButtonAppearance as B } from "../button/roche-button-types.js";
import { RocheUIImage as O } from "../image/roche-image.js";
import { RocheUIImageRatio as S } from "../image/roche-image.types.js";
import e from "./roche-teaser-card.module.scss.js";
import { RocheUITeaserCardLayout as l } from "./roche-teaser-card.types.js";
const V = /* @__PURE__ */ L(
  ({
    layout: s,
    title: m,
    description: c,
    overline: t,
    imageUrl: o,
    imageAlt: h,
    imageFit: _,
    buttonText: p,
    buttonLeftIcon: f,
    buttonRightIcon: I,
    href: R,
    target: i = "_self",
    onClick: d,
    slot: N,
    linkRef: u
  }, v) => {
    const n = s === l.CARD, U = s === l.DASHBOARD, x = n && o, A = i === "_blank", C = (D) => {
      d && d(D);
    };
    return /* @__PURE__ */ a(
      "div",
      {
        ref: v,
        slot: N,
        className: g(
          e["teaser-card"],
          n && e["teaser-card--card"],
          U && e["teaser-card--dashboard"]
        ),
        children: [
          x && /* @__PURE__ */ r("div", { className: e["teaser-card__image"], children: /* @__PURE__ */ r(
            O,
            {
              src: o,
              alt: h ?? "",
              imageFit: _,
              ratio: S.FIVETOFOUR
            }
          ) }),
          /* @__PURE__ */ a("div", { className: e["teaser-card__content"], children: [
            /* @__PURE__ */ a("div", { className: e["teaser-card__content-upper"], children: [
              t && /* @__PURE__ */ r("div", { className: e["teaser-card__overline"], children: t }),
              /* @__PURE__ */ r("h3", { className: e["teaser-card__title"], children: /* @__PURE__ */ r(
                "a",
                {
                  ref: u,
                  href: R,
                  target: i,
                  rel: A ? "noopener noreferrer" : void 0,
                  onClick: C,
                  className: e["teaser-card__link"],
                  children: m
                }
              ) }),
              c && /* @__PURE__ */ r("p", { className: e["teaser-card__description"], children: c })
            ] }),
            /* @__PURE__ */ r("div", { className: e["teaser-card__content-lower"], children: /* @__PURE__ */ r("div", { className: e["teaser-card__button"], children: /* @__PURE__ */ r(
              T,
              {
                appearance: B.SECONDARY,
                size: b.SMALL,
                text: p,
                leftIcon: f,
                rightIcon: I,
                hasMarginTop: !1,
                isDecorative: !0
              }
            ) }) })
          ] })
        ]
      }
    );
  }
);
export {
  V as RocheUITeaserCard
};
